import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 sm:p-2" data-id="element-252">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity cursor-pointer" onClick={onClose} aria-hidden="true" data-id="element-253" />

      {/* Modal Content */}
      <div className="relative bg-white rounded-2xl w-full max-w-3xl max-h-[85vh] flex flex-col shadow-2xl animate-in fade-in zoom-in-95 duration-200" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-254">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-gray-100 shrink-0" data-id="element-255">
          <h2 id="modal-title" className="text-xl font-black text-brand-navy" data-id="element-256">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-full transition-colors" aria-label="Cerrar modal" data-id="element-257">
            <XIcon className="w-5 h-5" data-id="element-258" />
          </button>
        </div>

        {/* Scrollable Body */}
        <div className="p-6 overflow-y-auto text-brand-textSecondary text-sm sm:text-base leading-relaxed" data-id="element-259">
          {children}
        </div>
      </div>
    </div>;
}